module.exports = __webpack_public_path__ + "static/media/logo-atulaya.fbfb36f9.png";